import classes from "../classes";
import { getCorrectedTime } from "../time";
import React from "react";

var interval;
var countdowns = [];

function updateCountdowns() {
  for (var i = 0; i < countdowns.length; i++) {
    countdowns[i].update();
  }
}

const timeFormat = new Intl.DateTimeFormat([], { timeStyle: "short" });
const dateFormat = new Intl.DateTimeFormat([], { dateStyle: "medium" });
const dayOfWeekFormat = new Intl.DateTimeFormat([], { weekday: "short" });

export default class Countdown extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      mode: this.getMode()
    };
    this.getDate = this.getDate.bind(this);
    this.getMode = this.getMode.bind(this);
    this.getRemainingTime = this.getRemainingTime.bind(this);
    this.getTooltip = this.getTooltip.bind(this);
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    countdowns.push(this);
    if (countdowns.length === 1) {
      interval = window.setInterval(updateCountdowns, 1000);
    }
  }

  componentWillUnmount() {
    countdowns = countdowns.filter(c => c !== this);
    if (countdowns.length === 0) {
      window.clearInterval(interval);
    }
  }

  update() {
    // using `setState()` every second to trigger re-renders is really slow when you get to like 60 of these on one screen
    // so instead we break out of React and update the html with `innerHTML`
    // and only use `setState()` when we transistion from full date, to different types of countdowns

    var { minutes, seconds } = this.getRemainingTime();
    var { mode } = this.state;
    var newMode = this.getMode();
    if (newMode !== mode) {
      // trigger a re-render
      this.setState({ mode: newMode }); // eslint-disable-line react/no-set-state
      return;
    }

    if (this.refs.minutes0) {
      var ms = minutes.toString();
      if (minutes < 10) {
        ms = "0" + ms;
      }
      ms.split("").forEach((c, i) => {
        this.refs["minutes" + i].innerHTML = c;
      });
    }
    if (this.refs.tooltip) {
      this.refs.tooltip.setAttribute("data-tooltip", this.getTooltip(minutes, seconds));
    }
  }

  getDate() {
    var { date } = this.props;
    if (typeof date === "string") {
      date = new Date(date);
    }
    return date;
  }

  getRemainingTime() {
    var { serverTimeDifference } = this.props;
    var date = this.getDate();
    var corrected = getCorrectedTime(new Date(), serverTimeDifference);

    var seconds = Math.floor((date - corrected) / 1000);
    var minutes = Math.floor((date - corrected) / 1000 / 60);
    seconds -= minutes * 60;

    if (minutes < 0 || seconds < 0) {
      return {
        minutes: 0,
        seconds: 0,
        pastMinutes: minutes,
        paseSeconds: seconds,
      };
    }
    return { minutes, seconds };
  }

  getMode() {
    var { tbd } = this.props;
    var { minutes, pastMinutes } = this.getRemainingTime();
    if (tbd) {
      return "tbd";
    }
    if (minutes >= 60) {
      return "full";
    }
    if (pastMinutes <= -60) {
      return "past";
    }
    if (minutes < 2) {
      return "warning";
    }
    if (minutes < 5 && minutes >= 2) {
      return "caution";
    }
    return "countdown";
  }

  getTooltip(minutes, seconds) {
    var { name } = this.props;
    return name + " is closing in " + minutes + " minutes and " + seconds + " seconds!";
  }

  render() {
    var { withDate } = this.props;
    var { mode } = this.state;
    var date = this.getDate();

    if (mode === "tbd") {
      return dateFormat.format(date);
    }
    if (mode === "full") {
      if (withDate) {
        return `${dayOfWeekFormat.format(date)} ${timeFormat.format(date)}`;
      } else {
        return timeFormat.format(date);
      }
    }
    if (mode === "past") {
      return dateFormat.format(date);
    }

    var { minutes, seconds } = this.getRemainingTime();

    var ms = minutes.toString();
    if (minutes < 10) {
      ms = "0" + ms;
    }
    /* eslint-disable react/no-array-index-key */
    var minutesCells = ms.split("").map((c, i) => (
      <li className="countdown_cell" key={ms.length - i} ref={"minutes" + i}>
        {c}
      </li>
    ));
    /* eslint-enable react/no-array-index-key */

    return (
      <ul
        className={classes({
          "countdown": true,
          "countdown--is-warning": mode === "warning",
          "countdown--is-caution": mode === "caution",
          "tooltip": true
        })}
        data-tooltip={this.getTooltip(minutes, seconds)}
        ref="tooltip">
        <li className="countdown_icon">
          <span className="dw-clock-o" />
        </li>

        {minutesCells}

        <li className="countdown_mtp">
          &nbsp;MTP
        </li>
      </ul>
    );
  }
}
